function matchingSelector(element, selector) {
  var proto = typeof Element !== "undefined" ? Element.prototype : {};
  var nativeFunction = proto.matches || proto.matchesSelector || proto.webkitMatchesSelector || proto.mozMatchesSelector || proto.msMatchesSelector || proto.oMatchesSelector;

  if (!element || element.nodeType !== 1 || !element.parentElement) {
    return false;
  }

  if (nativeFunction) {
    return nativeFunction.call(element, selector);
  }

  var matchingElements = element.parentElement.querySelectorAll(selector);

  for (var matchIdx in matchingElements) {
    if (matchingElements[matchIdx] === element) {
      return true;
    }
  }

  return false;
}

export { matchingSelector };